/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SimpleChartCard from './SimpleChartCard';
import EvolutiveChartCard from './EvolutiveChartCard';
import MultipleCrossChartCard from './MultipleCrossChartCard/index-beta';
import SimpleCrossChartCard from './SimpleCrossChartCard';
import CorrelationChartCard from './CorrelationChartCard';
// import SimulationChartCard from './SimulationChartCard';
import { cardsMap } from './cardsMap';
import * as Ui from './styles';

import { Loading } from '../../components/Loading';
import CrossEvolutiveChartCard from './EvolutiveCrossChartCard';

const propTypes = {
  customerId: PropTypes.number,
  surveyId: PropTypes.number,
  surveyTitle: PropTypes.string,
  questionId: PropTypes.number,
  questionTitle: PropTypes.string,
  maximizedCard: PropTypes.string,
  onMaximize: PropTypes.func,
  onMinimize: PropTypes.func,
  theme: PropTypes.object.isRequired,
};

const defaultProps = {
  customerId: null,
  surveyId: null,
  surveyTitle: null,
  questionId: null,
  questionTitle: null,
  maximizedCard: null,
  onMaximize: null,
  onMinimize: null,
};

export default function GroupCards(props) {
  // props from parent
  const { customerId, surveyId, surveyTitle, questionId, questionTitle } = props;

  // props from parent to maximization crontrols
  const {
    maximizedCard,
    onMaximize,
    onMinimize,
    theme,
  } = props;

  function renderLoading() {
    return <Loading size={30} running />;
  }

  function handleFullScreen(cardId, isFullScreenChanges) {
    if (isFullScreenChanges) {
      if (onMaximize) onMaximize(cardId);
    } else if (onMinimize) onMinimize();
  }
  
  return (
    <Ui.Wrapper>
      <Ui.CardGroup
        isFullScreen={
          maximizedCard === cardsMap.cruzamentosMultiplos.cardId
          || maximizedCard === cardsMap.graficoSimples.cardId
        }
        isSomeoneInFullScreen={maximizedCard && true}
      >
        {/* card: simple chart */}
        <SimpleChartCard
          customerId={customerId}
          surveyId={surveyId}
          surveyTitle={surveyTitle}
          questionId={questionId}
          questionTitle={questionTitle}
          isFullScreen={maximizedCard === cardsMap.graficoSimples.cardId}
          isSomeoneInFullScreen={maximizedCard && true}
          onFullScreenToggle={handleFullScreen}
          theme={theme}
        />
        {/* card: multi-cross chart */}
        <MultipleCrossChartCard
          customerId={customerId}
          surveyId={surveyId}
          surveyTitle={surveyTitle}
          questionId={questionId}
          questionTitle={questionTitle}
          isFullScreen={maximizedCard === cardsMap.cruzamentosMultiplos.cardId}
          isSomeoneInFullScreen={maximizedCard && true}
          onFullScreenToggle={handleFullScreen}
          theme={theme}
        />
      </Ui.CardGroup>
      {/* card: simple-cross chart */}
      <SimpleCrossChartCard
        customerId={customerId}
        surveyId={surveyId}
        surveyTitle={surveyTitle}
        questionId={questionId}
        questionTitle={questionTitle}
        isFullScreen={maximizedCard === cardsMap.cruzamentoSimples.cardId}
        isSomeoneInFullScreen={maximizedCard && true}
        onFullScreenToggle={handleFullScreen}
        theme={theme}
      />
      {/* card: evolution chart */}
      <EvolutiveChartCard
        customerId={customerId}
        surveyId={surveyId}
        surveyTitle={surveyTitle}
        questionId={questionId}
        questionTitle={questionTitle}
        isFullScreen={maximizedCard === cardsMap.graficoEvolutivo.cardId}
        isSomeoneInFullScreen={maximizedCard && true}
        onFullScreenToggle={handleFullScreen}
        theme={theme}
      />
      {/* card: cross evolution chart */}
      <CrossEvolutiveChartCard 
        customerId={customerId}
        surveyId={surveyId}
        surveyTitle={surveyTitle}
        questionId={questionId}
        questionTitle={questionTitle}
        isFullScreen={maximizedCard === cardsMap.graficoEvolutivoCruzamentos.cardId}
        isSomeoneInFullScreen={maximizedCard && true}
        onFullScreenToggle={handleFullScreen}
        theme={theme}
      />
      {/* card: correlation chart */}
      <CorrelationChartCard
        customerId={customerId}
        surveyId={surveyId}
        surveyTitle={surveyTitle}
        questionId={questionId}
        questionTitle={questionTitle}
        isFullScreen={maximizedCard === cardsMap.correlacao.cardId}
        isSomeoneInFullScreen={maximizedCard && true}
        onFullScreenToggle={handleFullScreen}
        theme={theme}
      />
      {/* card: simulation chart */}
      {/* <SimulationChartCard
        customerId={customerId}
        surveyId={surveyId}
        surveyTitle={surveyTitle}
        questionId={questionId}
        questionTitle={questionTitle}
        isFullScreen={maximizedCard === cardsMap.simulacao.cardId}
        isSomeoneInFullScreen={maximizedCard && true}
        onFullScreenToggle={handleFullScreen}
        theme={theme}
      /> */}
    </Ui.Wrapper>
  );
}

GroupCards.propTypes = propTypes;
GroupCards.defaultProps = defaultProps;
